import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import "./Factor.css";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AfterLoginNav from "../AfterLoginNav";

export default function ResultOrder({
  modalIsOpen,
  Openchanger,
  typeOrder,
  pk,
}) {
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "400px",
      height: "270px",
      border: "0px",
      overflowY: "hidden",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function afterOpenModal() {}
  function closeModal() {
    Openchanger(false);
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
        id={"factor-modal"}
      >
        <div className="header-modal-wrapper">
          <AfterLoginNav
            title={typeOrder === "buy" ? "پیش فاکتور خرید" : "پیش فاکتور فروش"}
            hasBack={closeModal}
          />
        </div>
        <div className={"container"} id={"factor-mbody"}>
          <div className="remove-cross" onClick={() => Openchanger(false)}>
            &#10006;
          </div>
          {isSmall ? (
            <div className="congrats-text-container">
              {typeOrder == "buy" ? (
                <div className="congrats-text">
                  تبریک!
                  <br />
                  درخواست خرید ثبت شد.
                </div>
              ) : (
                <div className="congrats-text">
                  تبریک!
                  <br />
                  درخواست فروش ثبت شد.
                </div>
              )}
              {typeOrder === "buy" ? (
                <div className="message-warning">
                  <img src={"/images/svg/warning-red.svg"} alt={""} />
                  طلای شما پس از تایید درخواست، خریداری می‌شود.
                </div>
              ) : (
                <div className="message-warning">
                  <img src={"/images/svg/warning-red.svg"} alt={""} />
                  طلای شما پس از تایید درخواست، به فروش می رسد.
                </div>
              )}
              <div className="buttons-result-container">
                <Link to={"/requests?active=" + typeOrder}>
                  <button className="form-input-button-custom">
                    پیگیری درخواست
                  </button>
                </Link>
              </div>
            </div>
          ) : (
            <div className="congrats-text-container">
              <div className="congrats-text">
                درخواست
                {typeOrder === "buy" ? " خرید " : " فروش "}
                با موفقیت ثبت شد.
              </div>
              <div className="message-warning flex-center">
                <img src={"/images/svg/warning-red.svg"} alt={""} />
                تکمیل فرایند خرید پس از تامین کالا و ذخیره سازی
              </div>

              <div className="message-warning flex-center">
                <img
                  src={"/images/text-red.svg"}
                  className="smaller-image-size"
                  alt={""}
                />
                از طریق صفحه پیگیری‌ها درخواست خود را دنبال کنید
              </div>
              <div className="buttons-result-container">
                <Link to={"/requests?active=" + typeOrder}>
                  <button className="form-input-button-custom">
                    پیگیری درخواست
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
